import type { SvgIconComponent } from "@mui/icons-material";
import SpaceDashboardOutlined from "@mui/icons-material/SpaceDashboardOutlined";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import DialpadOutlined from "@mui/icons-material/DialpadOutlined";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import ManageAccountsOutlined from "@mui/icons-material/ManageAccountsOutlined";
import HistoryOutlined from "@mui/icons-material/HistoryOutlined";
import type { Role } from "prisma-db/prisma/generated/portal-db";

export interface NavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
  /** Roles allowed to see the item. Mirrors the route guards exactly. */
  roles: Role[];
}

export interface NavSection {
  /** Section headings are hidden when the drawer is collapsed. */
  heading?: string;
  items: NavItem[];
}

// `USER` exists in the schema but the old Navbar showed it nothing beyond the
// dashboard, so it is deliberately absent from every other group.
const ALL: Role[] = ["ADMIN", "INTERNAL", "CUSTOMER", "USER"];
const STAFF: Role[] = ["ADMIN", "INTERNAL"];
const ADMIN_ONLY: Role[] = ["ADMIN"];

export const navSections: NavSection[] = [
  {
    items: [
      {
        label: "Dashboard",
        path: "/dashboard",
        icon: SpaceDashboardOutlined,
        roles: ALL,
      },
      {
        label: "Inventory",
        path: "/profile/customers",
        icon: Inventory2Outlined,
        roles: ["CUSTOMER"],
      },
    ],
  },
  {
    heading: "Search",
    items: [
      {
        label: "Numbers",
        path: "/search/number",
        icon: SearchOutlined,
        roles: STAFF,
      },
      {
        label: "Toll Free",
        path: "/search/tollfree",
        icon: DialpadOutlined,
        roles: STAFF,
      },
    ],
  },
  {
    heading: "Administration",
    items: [
      {
        label: "Customers",
        path: "/admin/customers",
        icon: BusinessOutlined,
        roles: STAFF,
      },
      {
        label: "Manage Users",
        path: "/admin/users",
        icon: ManageAccountsOutlined,
        roles: ADMIN_ONLY,
      },
      {
        label: "Domain Logs",
        path: "/admin/domain-logs",
        icon: HistoryOutlined,
        roles: ADMIN_ONLY,
      },
    ],
  },
];

export function visibleSections(role: Role | undefined): NavSection[] {
  if (!role) return [];
  return navSections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => item.roles.includes(role)),
    }))
    .filter((section) => section.items.length > 0);
}
